import { IconBase, IconProps, IconWeight } from '@phosphor-icons/react';
import { forwardRef, ReactElement } from 'react';

import { IconType } from './IconTypes';

const Icon: IconType = ({ color }) => (
  <>
    <path
      d="M14.6706 11.5H6.38058C6.19594 11.4999 6.01316 11.5369 5.84307 11.6087C5.67298 11.6806 5.51904 11.7858 5.39035 11.9182C5.26167 12.0506 5.16087 12.2075 5.09392 12.3796C5.02697 12.5517 4.99523 12.7354 5.00058 12.92V28.12C5.00058 28.3012 5.03627 28.4807 5.10563 28.6481C5.17498 28.8155 5.27663 28.9677 5.40477 29.0958C5.53292 29.224 5.68505 29.3256 5.85248 29.395C6.01991 29.4643 6.19936 29.5 6.38058 29.5H14.6706C15.0366 29.5 15.3876 29.3546 15.6464 29.0958C15.9052 28.837 16.0506 28.486 16.0506 28.12V12.92C16.0559 12.7354 16.0242 12.5517 15.9572 12.3796C15.8903 12.2075 15.7895 12.0506 15.6608 11.9182C15.5321 11.7858 15.3782 11.6806 15.2081 11.6087C15.038 11.5369 14.8552 11.4999 14.6706 11.5V11.5Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.00098 14.3H16.051"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.00098 26.74H16.051"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.7238 4.24108C19.6825 4.57133 19.656 4.78661 19.6501 4.95099C19.6443 5.11001 19.661 5.16821 19.6725 5.19523C19.7148 5.29494 19.7883 5.37821 19.882 5.43254C19.9074 5.44726 19.963 5.47107 20.1215 5.48507C20.2854 5.49954 20.5023 5.5 20.8351 5.5H24.1649C24.4977 5.5 24.7146 5.49954 24.8785 5.48507C25.037 5.47107 25.0926 5.44726 25.118 5.43254C25.2117 5.37821 25.2852 5.29494 25.3275 5.19523C25.339 5.16821 25.3557 5.11001 25.3499 4.95099C25.344 4.78662 25.3175 4.57133 25.2762 4.24108L25.1812 3.48108C25.1482 3.21672 25.1267 3.04749 25.1002 2.91935C25.075 2.7976 25.0525 2.75241 25.0374 2.72903C24.9875 2.65155 24.9171 2.58939 24.834 2.54943C24.8089 2.53737 24.7613 2.52066 24.6373 2.51077C24.5069 2.50037 24.3363 2.5 24.0699 2.5H20.9301C20.6637 2.5 20.4931 2.50037 20.3627 2.51077C20.2387 2.52066 20.1911 2.53737 20.166 2.54943C20.0829 2.58939 20.0125 2.65155 19.9626 2.72903C19.9475 2.75241 19.925 2.7976 19.8998 2.91935C19.8733 3.04749 19.8518 3.21672 19.8188 3.48108L19.7238 4.24108Z"
      stroke={color}
    />
    <path
      d="M18.5 9C18.5 8.04306 18.5011 7.37565 18.5688 6.87208C18.6345 6.3829 18.7548 6.12385 18.9393 5.93934C19.1238 5.75483 19.3829 5.63453 19.8721 5.56876C20.3756 5.50106 21.0431 5.5 22 5.5H23C23.9569 5.5 24.6244 5.50106 25.1279 5.56876C25.6171 5.63453 25.8762 5.75483 26.0607 5.93934L26.4056 5.59441L26.0607 5.93934C26.2452 6.12385 26.3655 6.3829 26.4312 6.87208C26.4989 7.37565 26.5 8.04306 26.5 9V10C26.5 10.9569 26.4989 11.6244 26.4312 12.1279C26.3655 12.6171 26.2452 12.8762 26.0607 13.0607C25.8762 13.2452 25.6171 13.3655 25.1279 13.4312C24.6244 13.4989 23.9569 13.5 23 13.5H22C21.0431 13.5 20.3756 13.4989 19.8721 13.4312C19.3829 13.3655 19.1238 13.2452 18.9393 13.0607L18.5944 13.4056L18.9393 13.0607C18.7548 12.8762 18.6345 12.6171 18.5688 12.1279C18.5011 11.6244 18.5 10.9569 18.5 10V9Z"
      stroke={color}
    />
    <path
      d="M19.7238 14.7589C19.6825 14.4287 19.656 14.2134 19.6501 14.049C19.6443 13.89 19.661 13.8318 19.6725 13.8048C19.7148 13.7051 19.7883 13.6218 19.882 13.5675C19.9074 13.5527 19.963 13.5289 20.1215 13.5149C20.2854 13.5005 20.5023 13.5 20.8351 13.5H24.1649C24.4977 13.5 24.7146 13.5005 24.8785 13.5149C25.037 13.5289 25.0926 13.5527 25.118 13.5675C25.2117 13.6218 25.2852 13.7051 25.3275 13.8048C25.339 13.8318 25.3557 13.89 25.3499 14.049C25.344 14.2134 25.3175 14.4287 25.2762 14.7589L25.1812 15.5189C25.1482 15.7833 25.1267 15.9525 25.1002 16.0806C25.075 16.2024 25.0525 16.2476 25.0374 16.271C24.9875 16.3485 24.9171 16.4106 24.834 16.4506C24.8089 16.4626 24.7613 16.4793 24.6373 16.4892C24.5069 16.4996 24.3363 16.5 24.0699 16.5H20.9301C20.6637 16.5 20.4931 16.4996 20.3627 16.4892C20.2387 16.4793 20.1911 16.4626 20.166 16.4506C20.0829 16.4106 20.0125 16.3485 19.9626 16.271C19.9475 16.2476 19.925 16.2024 19.8998 16.0806C19.8733 15.9525 19.8518 15.7833 19.8188 15.5189L19.7238 14.7589Z"
      stroke={color}
    />
  </>
);

const buildWeights = (color: string) =>
  new Map<IconWeight, ReactElement>([
    ['bold', <Icon color={color} strokeWidth={24} />],
    ['duotone', <Icon color={color} strokeWidth={16} opacity={0.2} />],
    ['fill', <Icon color={color} strokeWidth={16} opacity={1} />],
    ['light', <Icon color={color} strokeWidth={12} />],
    ['thin', <Icon color={color} strokeWidth={8} />],
    ['regular', <Icon color={color} strokeWidth={16} />],
  ]);

export const Watch = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <IconBase
    ref={ref}
    {...props}
    weights={buildWeights(props.color ?? 'currentColor')}
    viewBox="0 0 32 32"
    fill="none"
    strokeWidth="1.6"
  />
));

Watch.displayName = 'Watch';
